import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useUserDetail() {
    const { t } = useTranslation('accountSetting');
    const { data, status } = useQuery(queries.user.detail());
    const { pop } = useFlow();
    const toast = useToast();
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('toast.userDetailError'));
            pop();
        }
    }, [status, pop, toast, t]);
    return data;
}

export default useUserDetail;
